import { settlementService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    form_data: {
        id: '',
        full_name: '',
        amount: '',
        wage: '',
        website_address: '',
        created_at: '',
        updated_at: '',
        psp: '',
        sheba_number: '',
        gateway_id: '',
        gateway_farsi_name: '',
        status: '',
        tracking_code: '',
        description: ''
    },
    files: {}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, form_data) {
        state.status   = 'success'
        state.form_data = form_data
    },
    fetchFiles(state, files) {
        state.status   = 'success'
        state.files = files
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    files: ({files}) => files
}

const actions = {
    find({commit}, hashid) {
        commit('loading')
        
        return settlementService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchFiles({commit}) {
        commit('loading')

        return settlementService.fetchFiles().then(response => {
            commit('fetchFiles', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}